/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    EodMelcoModelsError,
    EodMelcoModelsErrorFromJSON,
    EodMelcoModelsErrorToJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodLog,
    EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodLogToJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail,
    EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSON,
    EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailToJSON,
} from '../models';

export interface EodSupportApiEodLogsRequest {
    deviceId: string;
}

export interface EodSupportApiEodMachinesRequest {
    allUserMachines?: boolean;
}

/**
 * 
 */
export class EodSupportApi extends runtime.BaseAPI {

    /**
     */
    async eodLogsRaw(requestParameters: EodSupportApiEodLogsRequest): Promise<runtime.ApiResponse<EodMelcoModelsGenericList1MelcoEodModelsEodLog>> {
        if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
            throw new runtime.RequiredError('deviceId','Required parameter requestParameters.deviceId was null or undefined when calling eodLogs.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/account/{device_id}/logs`.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters.deviceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsGenericList1MelcoEodModelsEodLogFromJSON(jsonValue));
    }

    /**
     */
    async eodLogs(requestParameters: EodSupportApiEodLogsRequest): Promise<EodMelcoModelsGenericList1MelcoEodModelsEodLog> {
        const response = await this.eodLogsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async eodMachinesRaw(requestParameters: EodSupportApiEodMachinesRequest): Promise<runtime.ApiResponse<EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.allUserMachines !== undefined) {
            queryParameters['all_user_machines'] = requestParameters.allUserMachines;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/eod/machines`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetailFromJSON(jsonValue));
    }

    /**
     */
    async eodMachines(requestParameters: EodSupportApiEodMachinesRequest): Promise<EodMelcoModelsGenericList1MelcoEodModelsEodMachineDetail> {
        const response = await this.eodMachinesRaw(requestParameters);
        return await response.value();
    }

}
